import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import MonthView from './MonthView';
import WeekView from './WeekView';

function Calendar() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState('Month');
  const [showSuggestions, setShowSuggestions] = useState(true);

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // Sample events data
  const events = {
    24: [
      {
        type: 'suggestion',
        title: 'Black Friday',
        description: 'Black Friday is the marquee event of the shopping year, offering your store a prime opportunity to boost sales and attract new...',
        platforms: ['klaviyo', 'meta', 'shopify', 'google-ads'],
        daysLeft: 5
      }
    ],
    27: [
      {
        type: 'suggestion',
        title: 'Cyber Monday',
        description: 'Cyber Monday is a prime opportunity to boost your online sales just after Black Friday\'s success. Leverage urgency and exclusive...',
        platforms: ['klaviyo', 'meta', 'shopify', 'google-ads'],
        daysLeft: 5
      }
    ],
    28: [
      {
        type: 'campaign',
        title: 'Giving Tuesday',
        platforms: ['klaviyo', 'meta']
      },
      {
        type: 'campaign',
        title: 'Thanksgiving Day (USA)',
        platforms: ['klaviyo', 'meta']
      }
    ],
    29: [
      {
        type: 'website',
        title: 'Homepage Banner',
        platform: 'shopify'
      },
      {
        type: 'campaign',
        title: 'Black Friday',
        platforms: ['klaviyo', 'meta', 'shopify', 'google-ads']
      }
    ],
    30: [
      {
        type: 'suggestion',
        title: 'Social Post',
        description: 'Ready to make this holiday unforgettable? Meet your new must-have: the [Product Name]. Designed to bring warmth, style, and effortless char...',
        platforms: ['meta'],
        product: true
      }
    ]
  };

  const goToPreviousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
  };

  const goToNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
  };

  const formatMonthYear = (date) => {
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  return (
    <div className="h-full bg-white">
      <header className="flex flex-col space-y-4 border-b border-gray-200 py-4 px-6">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-gray-900">Calendar</h1>
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              <span className="text-sm text-gray-500">✨</span>
              <button 
                className={`text-sm font-medium ${showSuggestions ? 'text-[#0049ac]' : 'text-gray-500'}`}
                onClick={() => setShowSuggestions(!showSuggestions)}
              >
                Suggestions
              </button>
            </div>
            <div className="flex items-center rounded-lg border border-gray-200 p-1">
              <button
                onClick={() => setView('Week')}
                className={`px-4 py-1.5 text-sm font-medium rounded-md ${
                  view === 'Week'
                    ? 'bg-[#0049ac] text-white'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Week
              </button>
              <button
                onClick={() => setView('Month')}
                className={`px-4 py-1.5 text-sm font-medium rounded-md ${
                  view === 'Month'
                    ? 'bg-[#0049ac] text-white'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Month
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-900 bg-white rounded-md border border-gray-300 hover:bg-gray-50"
          >
            Today
          </button>
          <div className="flex items-center space-x-2">
            <button
              onClick={goToPreviousMonth}
              className="p-2 text-gray-400 hover:text-gray-500"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <span className="text-sm font-medium text-gray-900">
              {formatMonthYear(currentDate)}
            </span>
            <button
              onClick={goToNextMonth}
              className="p-2 text-gray-400 hover:text-gray-500"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto">
        {view === 'Month' ? (
          <MonthView currentDate={currentDate} events={events} showSuggestions={showSuggestions} />
        ) : (
          <WeekView currentDate={currentDate} events={events} showSuggestions={showSuggestions} />
        )}
      </div>
    </div>
  );
}

export default Calendar;